var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_1242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_933_1242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V56H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_933_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 49.7182L17.3077 28.0002L8 6.28223L6.93652 8.76368L15.1808 28.0002L6.93652 47.2367L8 49.7182Z",
    fill: "#758494"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrowLong);
export default __webpack_public_path__ + "static/media/forward_arrow_long.534b0ec9e6b4891198e1200785c1a8d5.svg";
export { ForwardRef as ReactComponent };